import moment from "moment";

// The earliest deadline a customer may select: the day after pickup, unless
// the selected carrier can't deliver until later — a deadline before the
// carrier's earliest delivery date is impossible to meet
export function locationsFirstAllowedDeadlineDate(
  pickupDate: string,
  earliestDeliveryDate: string | undefined,
): moment.Moment {
  const dayAfterPickup = moment(pickupDate).startOf("day").add(1, "day");

  if (
    earliestDeliveryDate !== undefined &&
    moment(earliestDeliveryDate).startOf("day").isAfter(dayAfterPickup)
  ) {
    return moment(earliestDeliveryDate).startOf("day");
  }

  return dayAfterPickup;
}
